import request from '@/utils/request'
/*
统计报表
@y=>ws
*/
// 获取仓库名称
export function getckList() {
  return request({
    method: "get",
    url: "/yzdservice/enterprise/dwCk/getCkxxByCskc"
  });
}
// 获取 委托单位
export function getwtdwList() {
  return request({
    method: "get",
    url: "/yzdservice/api/storage/wtDw/list"
  });
}
// 获取库房库存列表
export function getkfkcList(data) {
  return request({
    method: "post",
    url: "/yzdservice/api/statistics/ck/kc",
    data: data,
    timeout: 1000 * 60
  });
}
// 获取仓储库存统计
export function getcckcList(data) {
  return request({
    method: "post",
    url: "/yzdservice/api/statistics/storage/kc",
    data: data
  });
}
// 获取仓储化学品出入库
export function getcchxpcrkcList(data) {
  return request({
    method: "post",
    url: "/yzdservice/api/statistics/storage/crk",
    data: data
  });
}
// 获取化学品出入库统计
export function gethxpcrkcList(data) {
  return request({
    method: "post",
    url:"/yzdservice/api/statistics/ck/crk",
    data: data,
    timeout: 1000 * 60
  });
}
